import { RESULT } from 'shared/api/query/constants';
import { computed, ref } from 'vue';
import { copy } from 'shared/lib/copy';
import {
  createEntityV2,
  deleteEntityV2, getUpdateTemplates,
  updateEntityV2,
} from '@/store/actions';
import { children as updateTemplateChildren, updateTemplateList } from '@/api/query/update-template';
import { updateTemplate as updateTemplateConfig } from 'shared/api/query/configs.json';
import { useStore } from 'vuex';

export default function useUpdateTemplatesRepo() {
  const store = useStore();

  const updateTemplates = computed(() => store.state.updateTemplate);

  const createSingleLoading = ref(false);
  const createSingle = (updateTemplate) => {
    createSingleLoading.value = true;
    return createEntityV2(store, {
      entity: updateTemplate,
      model: updateTemplateConfig.model,
      attributes: updateTemplateChildren,
      mutation: 'UPDATE_TEMPLATE_UPDATED',
    }).then((response) => {
      if (response.status !== 201) {
        throw new Error('failed to create update template');
      }
      return updateTemplates.value.find((v) => v.uid === response.data.uid);
    }).finally(() => {
      createSingleLoading.value = false;
    });
  };

  const updateSingleLoading = ref(false);
  const updateSingle = (updateTemplate) => {
    updateSingleLoading.value = true;
    const entity = updateTemplate;
    store.commit('UPDATE_TEMPLATE_UPDATED', { entity });
    return updateEntityV2(store, {
      entity: copy(entity),
      model: updateTemplateConfig.model,
      attributes: updateTemplateChildren,
      mutation: 'DO_NOTHING',
    }).then((response) => {
      if (response.status !== 200) {
        throw new Error('failed to update update template');
      }
      return updateTemplates.value.find((v) => v.uid === response.data.uid);
    }).finally(() => {
      updateSingleLoading.value = false;
    });
  };

  const deleteSingleLoading = ref(false);
  const deleteSingle = (updateTemplate) => {
    deleteSingleLoading.value = true;
    return deleteEntityV2(store, {
      entity: { uid: updateTemplate.uid },
      model: updateTemplateConfig.model,
    }).then((response) => {
      if (response.status !== 200) {
        throw new Error('failed to delete update template');
      }
    }).finally(() => {
      deleteSingleLoading.value = false;
    });
  };

  const getListLoading = ref(false);
  const getList = () => {
    getListLoading.value = true;
    return getUpdateTemplates(store, { queries: updateTemplateList() }).then((response) => {
      if (response.status !== 200) {
        throw new Error('failed to fetch updates');
      }
      const entities = response.data[RESULT];
      return entities.reduce((res, e) => {
        const ut = updateTemplates.value.find((v) => v.uid === e.uid);
        if (typeof ut !== 'undefined') {
          res.push(ut);
        }
        return res;
      }, []);
    }).finally(() => {
      getListLoading.value = false;
    });
  };

  return {
    getListLoading,
    getList,
    createSingleLoading,
    createSingle,
    updateSingleLoading,
    updateSingle,
    deleteSingleLoading,
    deleteSingle,

    updateTemplates,
  };
}
